











import { defineComponent, type PropType } from "vue-demi";
import type { Sale } from "@constructor/shared-entity/type";

export default defineComponent({
  name: "GGSaleCard",
  props: {
    data: {
      type: Object as PropType<Sale>,
      required: true,
    },
    size: {
      type: String as PropType<string>,
      default: "m",
      validator(el) {
        return ["s", "m"].some((item) => item === el);
      },
    },
  },
  computed: {
    link() {
      return this.data.path;
    },
  },
});
